export const oldGameIDs = ['H_BS', 'H_OE', 'H_BP', 'H_NIUNIU', 'H_LUCKY']
